export default {
  GET_CURRENT_TASK: (state) => {
    return state.currentTask;
  },
  GET_CURRENT_FOLDER: (state) => {
    return state.currentFolder;
  },
};
